// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2X-eW","header":"MergedInvoice_header__1Ivbb"};